module.exports = __webpack_public_path__ + "img/Aid.bfcf7cc2.svg";